import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { logger } from '../../utils/logger';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  
  useEffect(() => {
    // Log authentication state for debugging
    logger.debug('ProtectedRoute: Authentication state', { 
      currentUser: !!currentUser, 
      loading,
      isAuthenticated: sessionStorage.getItem('isAuthenticated') === 'true',
      sessionStorageKeys: Object.keys(sessionStorage)
    });
  }, [currentUser, loading]);

  if (loading) {
    // Show loading state while checking authentication
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Check both currentUser and sessionStorage for authentication
  const isAuthenticated = currentUser || sessionStorage.getItem('isAuthenticated') === 'true';
  
  if (!isAuthenticated) {
    // Save the current path to return after login
    sessionStorage.setItem('returnToPath', location.pathname);
    logger.debug('ProtectedRoute: Not authenticated, redirecting to login. Saved return path:', location.pathname);
    
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // If authenticated, render the protected content
  return children;
};

export default ProtectedRoute;
